import { fromJS } from "immutable";
import { find } from "lodash";
import { milliToDate } from "../../../../utils/commonUtil";
import { reverseMapAllocationType } from "./summaryConfig";
import {
  mapLoadingToResults,
  mapLoadingCancelToResults,
  sortLegalName,
} from "../../../../CommonComponents/CharitySearch/utils";
import { actionTypes } from "react-redux-form";
import { searchTermType as ragSearchTerm } from "../RecommendGrant/actionTypes";
import {
  accountDataSuccessType,
  disclaimerCheckboxType,
  switchAccountType,
  dataSuccessType,
  fetchRecentAgreementSuccessType,
  fetchSavedCharitySuccessType,
  fetchGrantHistoryType,
  fetchGrantHistorySuccessType,
  fetchGrantHistoryFailType,
  fetchPendingAgreementType,
  fetchPendingAgreementSuccessType,
  fetchPendingAgreementFailType,
  removeCharitySuccessType,
  selectCharityType,
  saveAgreementSuccessType,
  saveAgreementFailType,
  advisorAddressAgreementType,
  fundPoolUpdatedDataType,
  saveAgreementOneDataReducerType,
  newFlowType,
  resetFormType,
  postCountrySearchSuccessType,
  postCitySearchSuccessType,
  postCharitySearchSuccessType,
  cityLoaderType,
  geminiFilterType,
  updateFromType,
  updateFromLoadMoreCounterType,
  einDataType,
  geminiEINDataType,
  saveCharityType,
  saveCharitySuccessType,
  saveCharityFailType,
  searchTermType,
  searchGeminiSuccessType,
  postGeminiSavedDataType,
  enableEditType,
  resetEditType,
  confirmationPageSuccessType,
  fetchPoolSuccessType,
  fetchSpawnSuccessType,
  addCharitySuccessType,
  addCharityFailType,
  cancelSavedCharityType,
  clearAllReducerType,
  clearAllGeminiFilterType,
  geminiSearchTermType,
  postGeminiSavedDataSuccessType,
  postGeminiSavedDataFailType,
  updateFromCounterWorkerType,
} from "./actionTypes";

const initialState = fromJS({
  toUpdate: false,
  confirmationData: "",
  confirmationPool: "",
  accountData: {
    isLoading: true,
    data: {},
    error: "",
  },
  previewLetter: "",
  searchNextApi: 0,

  //NEW FORMS
  granteeOrgFirstName: "",
  granteeOrgLastName: "",
  granteeOrgEmailAddr: "",
  granteeOrgPhoneNumber: "",
  grantPurposeId: "",
  purpose: {
    description: undefined,
    additionalComments: null,
  },

  grantRecognition: {
    grantRecognition: null,
    permissionTo: "",
    thankIndividualName: null,
    accountName: null,
    notifyAdditionalNames: null,
    notifyFirstName: null,
    notifyLastName: null,
    inMemoryOfName: null,
    inHonorOfName: null,
    grantNotes: null,
    type: null,
    includeAdvisorInfo: true
  },

  weightedAllocFlag: undefined,
  advisorAddress: "",

  fundPool: [],

  permissionToPublish: false,

  grantAllocation: {
    amountAllocation: {
      amount: "",
    },
    grantAllocationSelect: "weightedPercentage",
    grantTable: {
      footerTotalPercentage: "",
      footerTotalAmount: "",
    },
    paymentInfoCard: {
      totalAmount: 0,
      remainingAmount: 0,
    },
    paymentComponent: {},
  },
  savedCharities: [],
  recentCharities: [],
  disclaimer: false,
  //search charity

  accountSelected: {
    isLoading: true,
    data: {},
    error: "",
  },
  savedCharity: {
    isLoading: true,
    error: "",
  },
  searchGemini: {
    isLoading: true,
    data: null,
    searchGeminiStringResponse: null,
    isGeminiSearch: false,
    error: "",
  },
  searchCity: {
    isLoading: true,
    data: null,
    error: "",
  },
  searchCounty: {
    isLoading: true,
    data: null,
    error: "",
  },
  cityLoader: {
    isLoading: true,
  },
  countyLoader: {
    isLoading: true,
  },
  charitySaved: false,
  // Charity Details
  selectedCharityName: "",
  selectedCharityAddress: "",
  selectedCharityId: "",
  selectedCharityEin: "",
  selectedCharityInterest: "",
  // Amount and Schedule
  searchCharity: {
    isLoading: true,
    data: [],
    isCharitySearch: false,
    error: "",
    guidestarSearchCount: "",
    serverDown: false,
  },
  spawns: [],
  geminiFilter: {
    showFilter: false,
  },
  from: 0,
  einData: "",
  geminiEinData: "",
  searchTerm: null,
  removeSuccessData: [],
  removeCharityData: [],
  lazyLoadingFlag: false,
  edit: false,
  pendingGrantsLoading: false,
  pendingGrants: [],
  pendingActiveSchedule: [],
  pendingGrantAgreement: [],
  grantHistoryLoading: false,
  grantHistory: [],
  scheduleHistory: [],
  poolsAllocation: [],
  poolsAllocationLoading: false,
  spawnData: {
    loading: true,
  },
  grantAgreementSearchTerm: null,
  grantAgreementGeminiSearchTerm: null,
});

export const filterGrantAgreementData = (unfilteredData) => {
  return unfilteredData.map((data) => ({
    id: data.grantAgreementId,
    remainingPayments: data.pendingPayments,
    endDate: data.gaEndDateString,
  }));
};

const grantAgreements = (state = initialState, action) => {
  switch (action.type) {
    case newFlowType: {
      return initialState;
    }
    case resetFormType: {
      return state
        .setIn(["fundPool"], [])
        .setIn(["grantAllocation", "grantTable"], {
          footerTotalPercentage: "",
          footerTotalAmount: "",
        })
        .setIn(["grantAllocationSelect"], "weightedPercentage")
        .setIn(["grantAllocation", "amountAllocation", "amount"], "")
        .setIn(["grantAllocation", "paymentComponent"], {})
        .setIn(["granteeOrgFirstName"], "")
        .setIn(["granteeOrgLastName"], "")
        .setIn(["granteeOrgEmailAddr"], "")
        .setIn(["granteeOrgPhoneNumber"], "")
        .setIn(["grantRecognition"], {
          grantRecognition: null,
          permissionTo: "",
          thankIndividualName: null,
          accountName: null,
          notifyAdditionalNames: null,
          notifyFirstName: null,
          notifyLastName: null,
          inMemoryOfName: null,
          inHonorOfName: null,
          grantNotes: null,
          type: null,
          includeAdvisorInfo: true
        })
        .setIn(["permissionToPublish"], false)
        .setIn(["purpose"], {
          description: undefined,
          additionalComments: null,
        })
        .setIn(["grantPurposeId"], "");
    }
    case dataSuccessType:
      return state
        .setIn(["accountData", "data"], action.payload)
        .setIn(["toUpdate"], !state.getIn(["toUpdate"]));
    case accountDataSuccessType:
      return state
        .setIn(["accountData", "data"], action.payload)
        .setIn(
          ["accountData", "isLoading"],
          !state.getIn(["accountData", "isLoading"])
        );
    case disclaimerCheckboxType:
      return state.setIn(["disclaimer"], action.payload);
    case fetchRecentAgreementSuccessType: {
      const { grantedCharity = [] } = action.payload;
      return state
        .setIn(["recentCharities"], grantedCharity)
        .setIn(["grantedCharity", "isLoading"], false);
    }

    case fetchSavedCharitySuccessType: {
      let sortedArray = sortLegalName(action.payload);
      return state
        .setIn(["savedCharities"], sortedArray)
        .setIn(["savedCharity", "isLoading"], false);
    }

    case fetchGrantHistoryType: {
      return state
        .setIn(["grantHistoryLoading"], true)
        .setIn(["grantHistory"], [])
        .setIn(["agreementHistory"], [])
        .setIn(["scheduleHistory"], []);
    }

    case fetchGrantHistorySuccessType: {
      const { grantsForCharity = {} } = action.payload;
      const {
        grants = [],
        activeSchedule = [],
        activeGrantAgreement = [],
      } = grantsForCharity;
      return state
        .setIn(["grantHistoryLoading"], false)
        .setIn(["grantHistory"], grants)
        .setIn(
          ["agreementHistory"],
          filterGrantAgreementData(activeGrantAgreement)
        )
        .setIn(["scheduleHistory"], activeSchedule);
    }

    case fetchGrantHistoryFailType: {
      return state
        .setIn(["grantHistoryLoading"], false)
        .setIn(["grantHistory"], [])
        .setIn(["agreementHistory"], [])
        .setIn(["scheduleHistory"], []);
    }

    case fetchPendingAgreementType: {
      return state
        .setIn(["pendingGrantsLoading"], true)
        .setIn(["pendingGrants"], [])
        .setIn(["pendingGrantAgreement"], [])
        .setIn(["pendingActiveSchedule"], []);
    }

    case fetchPendingAgreementSuccessType: {
      const { grantsForCharity = {} } = action.payload;
      const {
        grants = [],
        activeSchedule = [],
        activeGrantAgreement = [],
      } = grantsForCharity;
      return state
        .setIn(["pendingGrantsLoading"], false)
        .setIn(["pendingGrants"], grants)
        .setIn(
          ["pendingGrantAgreement"],
          filterGrantAgreementData(activeGrantAgreement)
        )
        .setIn(["pendingActiveSchedule"], activeSchedule);
    }

    case fetchPendingAgreementFailType: {
      return state
        .setIn(["pendingGrantsLoading"], false)
        .setIn(["pendingGrants"], [])
        .setIn(["pendingGrantAgreement"], [])
        .setIn(["pendingActiveSchedule"], []);
    }

    case selectCharityType: {
      const { id, name, address, ein } = action.payload;
      return state
        .setIn(["selectedCharityId"], id)
        .setIn(["selectedCharityName"], name)
        .setIn(["selectedCharityAddress"], address)
        .setIn(["selectedCharityEin"], ein);
    }
    case advisorAddressAgreementType: {
      return state.setIn(["advisorAddress"], action.payload);
    }

    case switchAccountType:
      return initialState;
    case fundPoolUpdatedDataType:
      const pools = action.payload.fundPool;
      const allocationPref = action.payload.allocationPref;
      let fundPoolTemp = [];
      let totalPercentage = 0;
      let totalAmount = 0;
      pools.forEach((pool) => {
        /** Storing Data for Fund Pool */
        let tempObj = {
          id: pool.id,
          name: pool.name,
          amountAllocated:
            allocationPref === "byDollars" ? pool.grantAmount : "",
          amountAllocatedWeighted:
            allocationPref === "weightedAllocations" ? pool.grantAmount : "",
          percentageAllocated:
            allocationPref === "byPercentage" ? pool.grantPercentage : "",
          position: {
            pool: {
              name: pool.name,
              number: "",
              poolId: pool.id.toString(),
            },
          },
          weightedPercenatgePerPool: pool.grantAmount.toString(),
        };
        fundPoolTemp.push(tempObj);

        /** Storing Data for Total Amount/Percentage */
        totalAmount += parseFloat(pool.grantAmount);
        totalPercentage += parseFloat(pool.grantPercentage);
      });
      return state
        .setIn(["fundPool"], fundPoolTemp)
        .setIn(["grantAllocation", "grantTable"], {
          footerTotalAmount: totalAmount,
          footerTotalPercentage: totalPercentage,
        })
        .setIn(["grantAllocationSelect"], allocationPref)
        .setIn(
          ["grantAllocation", "amountAllocation", "amount"],
          action.payload.amount
        )
        .setIn(
          ["grantAllocation", "paymentComponent", "payment"],
          action.payload.payment
        );

    case saveAgreementOneDataReducerType:
      let data = action.payload;
      let tempPayment = state.getIn([
        "grantAllocation",
        "paymentComponent",
        "payment",
      ]);
      const editStatus = state.getIn(["edit"]);
      const grantPayment = state.getIn([
        "grantAllocation",
        "paymentComponent",
        "payment",
      ]);
      if (grantPayment && (editStatus || grantPayment.length)) {
        tempPayment.forEach((element) => {
          if (element.requirementType)
            element.requirementType =
              data.purpose.description === "Other"
                ? "Narrative and Project budget"
                : "Annual report";
        });
      }
      return state
        .setIn(["granteeOrgFirstName"], data.granteeOrgFirstName)
        .setIn(["granteeOrgLastName"], data.granteeOrgLastName)
        .setIn(["granteeOrgEmailAddr"], data.granteeOrgEmailAddr)
        .setIn(["granteeOrgPhoneNumber"], data.granteeOrgPhoneNumber)
        .setIn(["grantRecognition"], data.grantRecognition)
        .setIn(["permissionToPublish"], data.permissionToPublish)
        .setIn(["purpose"], data.purpose)
        .setIn(["grantPurposeId"], data.grantPurposeId)
        .setIn(["grantAllocation", "paymentComponent", "payment"], tempPayment);

    case saveAgreementSuccessType:
      return state.setIn(["isSaveAgreementDone"], action.payload);

    case saveAgreementFailType:
      return state.setIn(["isSaveAgreementDone"], false);

    case enableEditType:
      return state.setIn(["edit"], action.payload);

    // Search charity flow

    case postCharitySearchSuccessType: {
      let prevData = state.getIn(["searchCharity", "data"]);
      let lazyLoadingFlag = state.get("lazyLoadingFlag");
      let searchSavedData = state.getIn(["savedCharities"]);
      const searchCharityResponse = action.payload.hits;
      const { serverDown } = action.payload;
      if (prevData === null) {

        loop1: for (let i = 0; i < searchSavedData.length; i++) {
          loop2: for (let j = 0; j < searchCharityResponse.length; j++) {
            if (searchSavedData[i].ein === searchCharityResponse[j].ein) {
              searchCharityResponse[j].isSelected = true;
              searchCharityResponse[j].granteeOrgAliasId =
                searchSavedData[i].granteeOrgAliasId;
              searchCharityResponse[j].charityId = searchSavedData[i].charityId;
              searchCharityResponse[j].isPending = searchSavedData[i].isPending;
              break loop2;
            }
          }
        }
        searchCharityResponse.foreach((item) => {
          if (!item.isSelected) {
            item.isSelected = false;
          }
        });

        return state
          .setIn(["searchCharity", "data"], searchCharityResponse)
          .setIn(
            ["searchCharity", "guidestarSearchCount"],
            action.payload.total_hits
          )
          .setIn(["searchCharity", "isLoading"], false)
          .setIn(["searchCharity", "serverDown"], serverDown)
          .setIn(["searchCharity", "isCharitySearch"], true);
      } else {
        if (searchSavedData.length === 0) {
          searchCharityResponse.forEach((record) => {
            record.isSelected = false;
          });
        }
        let flag = false;
        if (searchCharityResponse.length > 0) {
          loop1: for (let i = 0; i < searchSavedData.length; i++) {
            loop2: for (let j = 0; j < searchCharityResponse.length; j++) {
              if (searchSavedData[i].ein === searchCharityResponse[j].ein) {
                searchCharityResponse[j].isSelected = true;
                searchCharityResponse[j].granteeOrgAliasId =
                  searchSavedData[i].granteeOrgAliasId;
                searchCharityResponse[j].charityId =
                  searchSavedData[i].charityId;
                searchCharityResponse[j].isPending =
                  searchSavedData[i].isPending;
                break loop2;
              }
            }
          }
        }
        searchCharityResponse.forEach((item) => {
          if (!item.isSelected) {
            item.isSelected = false;
          }
        });

        if (lazyLoadingFlag === true) {
          for (let i = 0; i < searchCharityResponse.length; i++) {
            prevData = [...prevData, searchCharityResponse[i]];
          }
          return state
            .setIn(["searchCharity", "data"], prevData)
            .setIn(
              ["searchCharity", "guidestarSearchCount"],
              action.payload.total_hits
            )
            .setIn(["searchCharity", "isLoading"], false)
            .setIn(["searchCharity", "serverDown"], serverDown)
            .setIn(["searchCharity", "isCharitySearch"], true)
            .set("lazyLoadingFlag", false);
        }

        return state
          .setIn(["searchCharity", "data"], searchCharityResponse)
          .setIn(
            ["searchCharity", "guidestarSearchCount"],
            action.payload.total_hits
          )
          .setIn(["searchCharity", "isLoading"], false)
          .setIn(["searchCharity", "serverDown"], serverDown)
          .setIn(["searchCharity", "isCharitySearch"], true);
      }
    }
    case postGeminiSavedDataSuccessType: {
      let submitGeminiData = action.payload;
      const { prevData = {} } = action;

      return state
        .updateIn(["searchGemini", "data"], (searchResults) =>
          searchResults.map((record) => {
            if (record.granteeOrgId === prevData.granteeOrgId) {
              record.isPending = action.payload.isPending;
              return {
                ...record,
                isSelected: true,
                granteeOrgAliasId: submitGeminiData.granteeOrgAliasId,
                loading: false,
              };
            }
            return { ...record };
          })
        )
        .setIn(["charitySaved"], true);
    }

    case postGeminiSavedDataFailType: {
      const { prevData = {} } = action;
      return state
        .setIn(["charitySaved"], false)
        .updateIn(["searchGemini", "data"], (searchResults) =>
          mapLoadingCancelToResults(searchResults, prevData, "granteeOrgId")
        );
    }

    case postGeminiSavedDataType: {
      const { charityData = {} } = action.payload;
      return state
        .setIn(["charitySaved"], false)
        .updateIn(["searchGemini", "data"], (searchResults) =>
          mapLoadingToResults(searchResults, charityData, "granteeOrgId")
        );
    }

    case einDataType: {
      let searchData = state.getIn(["searchCharity", "data"]);
      let searchCharityData = searchData.splice(0);
      let newSearchCharity;
      newSearchCharity = searchCharityData.map((obj) => {
        if (obj.granteeOrgAliasId === action.payload) {
          obj.isSelected = false;
        }
        return obj;
      });
      return state
        .set("einData", action.payload)
        .setIn(["searchCharity", "data"], newSearchCharity);
    }

    case saveCharityType: {
      const { charityData = {} } = action.payload;
      return state
        .setIn(["charitySaved"], false)
        .updateIn(["searchCharity", "data"], (searchResults) =>
          mapLoadingToResults(searchResults, charityData, "ein")
        );
    }

    case saveCharitySuccessType: {
      const { prevData = {} } = action;
      return state
        .updateIn(["searchCharity", "data"], (searchResults) =>
          searchResults.map((obj) => {
            if (obj.ein === prevData.ein && action.payload.success) {
              return {
                ...obj,
                charityId: action.payload.charityId,
                granteeOrgAliasId: action.payload.granteeOrgAliasId,
                isSelected: true,
                loading: false,
              };
            }
            return { ...obj };
          })
        )
        .set("charitySaved", action.payload.success);
    }

    case addCharitySuccessType: {
      const { prevData = {} } = action;
      return state
        .updateIn(["searchCharity", "data"], (searchResults) =>
          searchResults.map((obj) => {
            if (obj.ein === prevData.ein && action.payload) {
              return {
                ...obj,
                charityId: prevData.granteeOrgId,
                granteeOrgAliasId: action.payload,
                isSelected: true,
                loading: false,
              };
            }
            return { ...obj };
          })
        )
        .setIn(["charitySaved"], true);
    }

    case saveCharityFailType:
    case addCharityFailType: {
      const { prevData = {} } = action;
      return state
        .setIn(["charitySaved"], false)
        .updateIn(["searchCharity", "data"], (searchResults) =>
          mapLoadingCancelToResults(searchResults, prevData, "ein")
        );
    }

    case cancelSavedCharityType: {
      const prevData = action.payload;
      return state
        .setIn(["charitySaved"], false)
        .updateIn(["searchCharity", "data"], (searchResults) =>
          mapLoadingCancelToResults(searchResults, prevData, "ein")
        );
    }

    case updateFromCounterWorkerType: {
      const nextCounter = state.getIn(["searchNextApi"]) + action.payload;
      return state.setIn(["searchNextApi"], nextCounter);
    }
    case geminiFilterType: {
      return state.setIn(["geminiFilter", "showFilter"], action.payload);
    }

    case updateFromType:
      let prevValue = state.get("from");
      prevValue = prevValue + 25;
      let prevData = state.getIn(["searchCharity", "data"]);

      return state.set("from", prevValue).set("lazyLoadingFlag", true);

    case ragSearchTerm:
      return state.set("searchTerm", action.payload);

    case searchGeminiSuccessType: {
      const searchSavedData = state.getIn(["savedCharities"]);
      if (typeof action.payload === "string") {
        return state
          .setIn(["searchGemini", "searchGeminiStringResponse"], action.payload)
          .setIn(["searchGemini", "data"], [])
          .setIn(["searchGemini", "isLoading"], false)
          .setIn(["searchGemini", "isGeminiSearch"], true);
      }
      if (action.payload.length > 0) {
        action.payload.forEach((record) => {
          if (record.granteeOrgAliasId !== 0) {
            record.isSelected = false;
            const savedCharityMatch = find(searchSavedData, {
              charityId: parseInt(record.granteeOrgId),
            });
            if (savedCharityMatch) {
              record.isPending = savedCharityMatch.isPending;
              record.charityId = savedCharityMatch.charityId;
              record.isSelected = true;
              record.granteeOrgAliasId = searchSavedData.granteeOrgAliasId;
            }
          } else {
            record.isSelected = false;
          }
        });
      }
      return state
        .setIn(["searchGemini", "data"], action.payload)
        .setIn(["searchGemini", "searchGeminiStringResponse"], "")
        .setIn(["searchGemini", "isLoading"], false)
        .setIn(["searchGemini", "isGeminiSearch"], true);
    }

    case geminiEINDataType: {
      let searchData = state.getIn(["searchGemini", "data"]);
      let searchGeminiData = searchData.splice(0);
      let newSearchGemini;
      newSearchGemini = searchGeminiData.map((obj) => {
        if (obj.ein && obj.ein === action.payload) {
          obj.isSelected = false;
        }
        return obj;
      });
      return state
        .set("geminiEinData", action.payload)
        .setIn(["searchGemini", "data"], newSearchGemini);
    }

    case cityLoaderType:
      return state.setIn(["cityLoader", "isLoading"], false);

    case postCitySearchSuccessType:
      return state
        .setIn(["searchCity", "data"], action.payload)
        .setIn(["searchCity", "isLoading"], false)
        .setIn(["cityLoader", "isLoading"], false);

    case postCountrySearchSuccessType:
      return state
        .setIn(["searchCounty", "data"], action.payload)
        .setIn(["searchCounty", "isLoading"], false)
        .setIn(["countyLoader", "isLoading"], false);

    case updateFromLoadMoreCounterType:
      let nextLoadMoreCounter = state.get(
        "searchLoadMoreApi",
        action.payload.payload
      );
      nextLoadMoreCounter = nextLoadMoreCounter + 10;
      return state.set("searchLoadMoreApi", nextLoadMoreCounter);

    case resetEditType:
      return state.setIn(["edit"], false);
    case confirmationPageSuccessType:
      const { investmentType, grantAgreementAmount } = action.payload;
      const { investmentOptions } = action.payload.paymentInformation;
      let poolDatas = investmentOptions.map((investment) => ({
        investionOption: investment.investionOption,
        availableBalance: investment.availableBalance,
        pricePerUnit: investment.pricePerUnit,
        percentage:
          investmentType === "By Specified Percent"
            ? parseFloat(investment.amount)
            : (
                (parseFloat(investment.amount) /
                  parseFloat(grantAgreementAmount)) *
                100
              ).toFixed(2),
        amount:
          investmentType === "By Specified Percent"
            ? (
                (parseFloat(grantAgreementAmount) *
                  parseFloat(investment.amount)) /
                100
              ).toFixed(2)
            : parseFloat(investment.amount),
      }));
      return state
        .setIn(["confirmationData"], action.payload)
        .setIn(["confirmationPool"], poolDatas);
    case actionTypes.fetchPoolsType: {
      return state
        .setIn(["poolsAllocation"], [])
        .setIn(["poolsAllocationLoading"], true);
    }
    case fetchPoolSuccessType: {
      const poolsData = action.payload;
      const requiredData = poolsData.map((poolInfo) => ({
        poolId: poolInfo.poolId,
        poolName: poolInfo.poolName,
        availableBalance: poolInfo.availableBalance,
        percentShare: poolInfo.percentShare,
      }));
      return state
        .setIn(["poolsAllocation"], requiredData)
        .setIn(["poolsAllocationLoading"], false);
    }
    case clearAllReducerType: {
      return state.setIn(["searchCharity", "isCharitySearch"], false);
    }

    case clearAllGeminiFilterType: {
      return state.setIn(["searchGemini", "isGeminiSearch"], false);
    }

    case searchTermType:
      return state.set("grantAgreementSearchTerm", action.payload);

    case geminiSearchTermType:
      return state.set("grantAgreementGeminiSearchTerm", action.payload);

    //View Spawn Grant Agreement
    case fetchSpawnSuccessType: {
      const {
        charityName: selectedCharityName,
        ein,
      } = action.payload.charityDetails;
      const {
        streetAddress,
        line2,
        line3,
        state: _state,
        city,
        zip,
        stateType: country, //Keeping it stateType as country is coming null
      } = action.payload.charityDetails;
      const address = `${streetAddress}, ${line2 ? line2 + "," : ""} ${
        line3 ? line3 + "," : ""
      }${city ? city : ""}, ${_state ? _state : ""} ${zip}, ${
        country ? country : ""
      }`;

      // Section that populates Transaction details
      const { charityId } = action.payload;

      // Section that populates Purpose and Recognition Details
      const {
        purpose,
        notify,
        publishName,
        additionalAttribution,
        purposeId,
        recognitionId,
        additionalComments,
        projectName,
        eventName,
        missionaryName,
        missionaryLocation,
        certificationRequired,
        type: recogntionType,
      } = action.payload.recognitionOptions;
      const [notifyFirstName, notifyLastName] = notify
        ? notify.split(" ")
        : ["", ""];

      // Section that populates Payment and Allocation Details
      const {
        payment,
        issueDate,
        scheduleEndDate,
        noOfPayments,
        enteredDate,
        amount,
        frequency,
        allocationPreference,
        grantAllocation,
        grantId,
        scheduleStartDate,
        grantAmount,
        status,
        pendingSpawnId,
        checkIssuedDate,
        allShareallPool,
        allShareSpecificPool,
        checkNumber,
      } = action.payload;

      const paymentType =
        // Single time comes from spawns and single payment from recurring
        payment &&
        (payment.toLowerCase() === "single payment" ||
          payment.toLowerCase() === "single time")
          ? "oneTime"
          : "recurring";
      const grantedAmount = paymentType === "oneTime" ? amount : grantAmount;

      let startDate = paymentType === "oneTime" ? issueDate : scheduleStartDate;

      if (pendingSpawnId) {
        // Spawn flow. Date is coming in as timestamp unlike grant
        startDate = issueDate ? milliToDate(issueDate) : "—";
        //cant set null because it will default to as soon as possible
        startDate =
          startDate && startDate.toLowerCase() === "invalid date"
            ? "-"
            : startDate;
        //insurance not to reopen invalid date being displayed issue
      }

      startDate =
        !startDate || typeof startDate === "string"
          ? startDate
          : milliToDate(parseFloat(startDate));

      // recognition id 20 stands for accounts advisors, account and third party
      // third party is being returned as type inside recognitionOptions when id = 20
      let thirdParty = "";
      if (recognitionId === "20") {
        thirdParty = recogntionType;
      }

      const allocationType =
        allocationPreference && reverseMapAllocationType(allocationPreference);
      const allocations = grantAllocation.map((allocation) => ({
        id: allocation.poolId,
        name: allocation.option,
        units: allocation.allShareSpecificPool ? allocation.value : 0,
        grantAmount:
          !allocation.allShareSpecificPool && allocationType !== "byPercentage"
            ? allocation.value
            : (
                (parseFloat(grantedAmount) * parseFloat(allocation.value)) /
                100
              ).toFixed(2),
        grantPercentage:
          !allocation.allShareSpecificPool && allocationType === "byPercentage"
            ? allocation.value
            : (
                (parseFloat(allocation.value) / parseFloat(grantedAmount)) *
                100
              ).toFixed(2),
        allShare: allocation.allShareSpecificPool,
      }));

      return state
        .setIn(["spawnData", "selectedCharityName"], selectedCharityName)
        .setIn(["spawnData", "selectedCharityAddress"], address)
        .setIn(["spawnData", "selectedCharityId"], charityId)
        .setIn(["spawnData", "selectedCharityEin"], ein)
        .setIn(
          ["spawnData", "enteredDate"],
          enteredDate ? milliToDate(enteredDate) : ""
        )
        .setIn(
          ["spawnData", "checkIssuedDate"],
          checkIssuedDate ? milliToDate(Number(checkIssuedDate)) : ""
        )
        .setIn(["spawnData", "checkNumber"], checkNumber)
        .setIn(["spawnData", "grantPurposeName"], purpose)
        .setIn(["spawnData", "grantPurposeId"], parseInt(purposeId))
        .setIn(["spawnData", "grantRecognition"], recognitionId)
        .setIn(["spawnData", "honorOf"], additionalAttribution.inHonorOf)
        .setIn(["spawnData", "memoryOf"], additionalAttribution.inMemoryOf)
        .setIn(["spawnData", "notifyFirstName"], notifyFirstName)
        .setIn(["spawnData", "notifyLastName"], notifyLastName)
        .setIn(["spawnData", "permissionToPublish"], publishName === "Yes") // If publishName = "No", then checkbox is checked
        .setIn(["spawnData", "purposeComments"], additionalComments)
        .setIn(["spawnData", "missionaryName"], missionaryName)
        .setIn(["spawnData", "eventName"], eventName)
        .setIn(["spawnData", "missionaryLocation"], missionaryLocation)
        .setIn(["spawnData", "projectName"], projectName)
        .setIn(["spawnData", "purposeCertification"], certificationRequired)
        .setIn(["spawnData", "advisorThirdPartyComment"], thirdParty)

        .setIn(["spawnData", "grantAmount"], grantedAmount)
        .setIn(["spawnData", "startDate"], startDate)
        .setIn(
          ["spawnData", "endDate"],
          scheduleEndDate ? milliToDate(scheduleEndDate) : ""
        )
        .setIn(["spawnData", "frequency"], frequency)
        .setIn(["spawnData", "noOfPayments"], noOfPayments)
        .setIn(["spawnData", "scheduleType"], paymentType)
        .setIn(["spawnData", "allocationType"], allocationType)
        .setIn(["spawnData", "allocations"], allocations)
        .setIn(["spawnData", "allSharesAllPools"], allShareallPool)
        .setIn(["spawnData", "allShares"], allShareSpecificPool)

        .setIn(["spawnData", "grantId"], grantId)
        .setIn(["spawnData", "loading"], false)
        .setIn(["spawnData", "status"], status);
    }

    case removeCharitySuccessType: {
      if (action.payload.payload.searchType === "gemini") {
        const searchGemini = state.getIn(["searchGemini", "data"]);
        if (searchGemini && searchGemini.length) {
          searchGemini.forEach((data) => {
            if (
              data.granteeOrgAliasId &&
              data.granteeOrgAliasId == action.payload.payload.charityId
            ) {
              data.isPending = false;
              data.isSelected = false;
            }
          });
        }
        return state.setIn(["searchGemini", "data"], searchGemini);
      } else {
        let searchData = state.getIn(["searchCharity", "data"]);
        if (searchData && searchData.length) {
          searchData.forEach((data) => {
            if (
              data.granteeOrgAliasId &&
              data.granteeOrgAliasId == action.payload.payload.charityId
            ) {
              data.isPending = false;
              data.isSelected = false;
            }
          });
        }
        return state.setIn(["searchCharity", "data"], searchData);
      }
    }

    default:
      return state;
  }
};

export default grantAgreements;
